import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// import hooks
import { useState } from "react";
import { QUADRUPLE } from "../../../../constants/numbers.consts.js";
import List from "../../../../components/atoms/List/index.js";
import RotatingIcon from "../../../../components/atoms/RotatingIcon/index.js";
import Typography from "../../../../components/atoms/Typography/index.js";
import Collapse from "../../../../components/atoms/Collapse/index.js";
import { MobileMenuItem } from "../MobileMenu.components.js";
const rotatingIconSx = { marginLeft: "auto" };
export const MobileMenuSubItemComponent = ({ id, label, submenu, selectedId, 
// isLoading,
onClick, ...props }) => {
    const hasSubmenu = !!submenu?.length;
    const hasSubmenuItemSelected = !!submenu?.find((sub) => sub.id === selectedId);
    const [open, setOpen] = useState(hasSubmenuItemSelected);
    const _clickHandler = () => {
        if (hasSubmenu) {
            setOpen((o) => !o);
        }
        else {
            onClick?.();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(MobileMenuItem, { onClick: _clickHandler, selected: selectedId === id || hasSubmenuItemSelected, ...props, children: [_jsx(Typography, { noWrap: true, prominent: selectedId === id, children: label }), hasSubmenu && (_jsx(RotatingIcon, { direction: open ? "asc" : "desc", type: "caret-up", color: "inherit", sx: rotatingIconSx }))] }), _jsx(Collapse, { in: open, children: _jsx(List, { sx: { paddingLeft: ({ spacing }) => spacing(QUADRUPLE) }, children: submenu?.map(({ label: _label, ...subItem }, i) => (_jsx(MobileMenuItem, { selected: selectedId === subItem.id, ...subItem, children: _jsx(Typography, { prominent: selectedId === subItem.id, children: _label }) }, subItem.id ?? i))) }) })] }));
};
export default MobileMenuSubItemComponent;
